export const footerDataObj = {
  neurotx:
    "NeuroTX Aachen e.V. ist eingetragen beim Amtsgericht Aachen, Nr. VR 6094.",
  repr: "Vertretungsberechtigter Vorstand gemäß § 26 BGB: Philipp Ljubarskij.",
  copyright: "Copyright © 2022 NeuroTX-Aachen",
  contact: {
    name: "Contact us",
    list: [
      { title: "neurotx.aachen@gmail.com", url: "neurotx.aachen@gmail.com" },
      { title: "Instagram", url: "https://www.instagram.com/neurotx.aachen/" },
      { title: "Facebook", url: "https://www.facebook.com/neurotxaachen" },
      { title: "Twitter", url: "https://twitter.com/NeurotxAachen" },
    ],
  },
  address: {
    name: "NeuroTX Aachen e.V.",
    co: "Collective Incubator e.V.",
    street: "Jülicher Str. 209",
    postcode: "52070",
    city: "Aachen",
  },
};
